// src/components/project/AnalyticsControl.jsx
import { useState, useEffect, useMemo } from 'react';
import api from '../../services/api';
import FlatpickrInput from '../FlatpickrInput';

const AnalyticsControl = () => {
  const [adminStatus, setAdminStatus] = useState({ status: false, start_date: null });
  const [startDate, setStartDate] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAnalyticsStatus = async () => {
      try {
        const res = await api.get('/analytics/status');
        const data = res.data || { status: false, start_date: null };
        setAdminStatus(data);
        if (data.start_date) {
          setStartDate(data.start_date);
        }
      } catch (err) {
        console.error('Ошибка при загрузке статуса аналитики:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchAnalyticsStatus();
  }, []);

  const toggleAnalytics = async () => {
    try {
      await api.post('/analytics/toggle');
      setAdminStatus((prev) => ({ ...prev, status: !prev.status }));
      window.showToast('Аналитика обновлена');
    } catch (err) {
      console.error('Ошибка при переключении аналитики:', err);
    }
  };

  const handleSetStartDate = async (value) => {
    try {
      await api.post('/analytics/start_date', { start_date: value });
      setStartDate(value);
      window.showToast('Дата анализа сохранена');
    } catch (err) {
      console.error('Ошибка при установке даты:', err);
    }
  };

  const renderContent = useMemo(() => {
    if (loading) return null;

    return (
      <div className="mb-4 d-flex flex-wrap align-items-center" style={{ gap: '10px' }}>
        {/* Кнопка вкл/выкл аналитики */}
        <form onSubmit={(e) => { e.preventDefault(); toggleAnalytics(); }} className="d-inline">
          <button
            type="submit"
            className={`btn btn-sm ${adminStatus.status ? 'btn-success' : 'btn-warning'}`}
          >
            {adminStatus.status ? 'Выключить аналитику' : 'Включить аналитику'}
          </button>
        </form>

        {/* Выбор даты */}
        <div className="d-flex align-items-center" style={{ gap: '5px' }}>
          <label className="form-label mb-0" style={{ fontSize: '0.85rem' }}>
            Дата начала:
          </label>
          <FlatpickrInput
            value={startDate}
            onChange={handleSetStartDate}
            placeholder="дд-мм-гггг чч:мм:сс"
          />
        </div>
      </div>
    );
  }, [adminStatus, startDate, loading]);

  return renderContent;
};

export default AnalyticsControl;
